<template>
    <div v-loading="!is_ok" style="position: relative">
        <div style="width: 100%;height: 100%" ref="main"></div>
        <div class="select_btn">
            <el-radio-group v-model="year" size="mini" @change="date_change">
                <el-radio-button label="last_year">去年</el-radio-button>
                <el-radio-button label="to_year">今年</el-radio-button>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts/core'
import { TooltipComponent, LegendComponent,TitleComponent,ToolboxComponent,GridComponent} from 'echarts/components'
import request from '@/utils/request'
import { BarChart, LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use(
    [ToolboxComponent, TooltipComponent,TitleComponent,GridComponent, LegendComponent, BarChart, LineChart, CanvasRenderer]
);

export default {
    name: 'sales_charts',
    data(){
        return {
            option:{
                color:["#b6a2de","#2ec7c9","#459af8","#ffb980","#d87a80","#5ab1ef","#6cdefb","#e5cf0d"],
                title:{
                    show:true,
                    text:"销量价格统计图 (月)",
                    textStyle:{
                        color:"#95aac9",
                        fontWeight:"normal"
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                grid:{
                    right: '15%',
                    top:"25%",
                    bottom:"10%"
                },
                legend: {
                    data: ['当期销售额', '往期销售额', '当期价格','往期价格','同比','环比','当前销售量','往期销售量']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '销售额',
                        // min: 0,
                        // max: 250,
                        // interval: 50,
                        splitNumber:4,
                        axisLabel: {
                            formatter: '{value} 万元'
                        }
                    },
                    {
                        type: 'value',
                        name: '价格',
                        // min: 0,
                        // max: 25,
                        splitNumber:4,
                        position: 'right',
                        // interval: 5,
                        axisLabel: {
                            formatter: '{value} 元/吨'
                        }
                    },
                    {
                        type: 'value',
                        name: '同比',
                        position: 'right',
                        offset: 80,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#d87a80",
                                type:"dashed"
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %'
                        },
                        min:"-100",
                        max:function (value) {
                            return Math.floor(Math.floor(value.max + 100)/10)*10;
                        }
                    },
                    {
                        type: 'value',
                        name: '环比',
                        position: 'right',
                        offset: 130,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#e5cf0d",
                                type:"dotted"
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %'
                        },
                        min:"-100",
                        max:function (value) {
                            return Math.floor(Math.floor(value.max + 100)/10)*10;
                        }
                    },
                ],
                series: [
                    {
                        name: '当期销售额',
                        type: 'bar',
                        data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
                        itemStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                            borderRadius:[8,8,0,0]
                        }
                    },
                    {
                        name: '往期销售额',
                        type: 'bar',
                        data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
                        itemStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                            borderRadius:[8,8,0,0]
                        }
                    },
                    {
                        name: '当期价格',
                        type: 'line',
                        yAxisIndex: 1,
                        smooth: true,
                        data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
                        lineStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                        }
                    },
                    {
                        name: '往期价格',
                        type: 'line',
                        yAxisIndex: 1,
                        smooth: true,
                        data: [0, 0, 0, 0, 0, 0,0,0,0,0,0,0],
                        lineStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                        }
                    },
                    {
                        name: '同比',
                        type: 'line',
                        yAxisIndex: 2,
                        smooth: true,
                        data: [40, 20, 30, 10, 70, 80,33,22,66,83,5,9],
                        lineStyle:{
                            type:"dashed"
                        }
                    },
                    {
                        name: '环比',
                        type: 'line',
                        yAxisIndex: 3,
                        smooth: true,
                        data: [100, 30, -20, -10, -5, 2,1,7,32,50,34,2],
                        lineStyle:{
                            type:"dotted"
                        }
                    },
                    {
                        name: '当前销售量',
                        type: 'bar',
                        //yAxisIndex: 3,
                        //smooth: true,
                        data: [100, 30, -20, -10, -5, 2,1,7,32,50,34,2],
                        itemStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                            borderRadius:[8,8,0,0]
                        }
                    },
                    {
                        name: '往期销售量',
                        type: 'bar',
                        //yAxisIndex: 3,
                        //smooth: true,
                        data: [100, 30, -20, -10, -5, 2,1,7,32,50,34,2],
                         itemStyle:{
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            shadowBlur: 4,
                            borderRadius:[8,8,0,0]
                        }
                    },
                ]
            },
            chart:null,
            is_ok:false,
            year:"to_year"
        }
    },
    methods:{
        date_change(value){
            if(value == "to_year"){
                this.getData(1);
            }else{
                this.getData(0);
            }
        },
        getData(mode){
            this.is_ok = false;
            request.get("index/sale_amount_price_month?mode="+mode).then(res=>{
                this.option.series[0].data = res.data.currAmounts;
                this.option.series[1].data = res.data.pastAmounts;
                this.option.series[2].data = res.data.currPrices;
                this.option.series[3].data = res.data.pastPrices;
                this.option.series[4].data = res.data.tb;
                this.option.series[5].data = res.data.hb;
                this.option.series[6].data = res.data.currWeights;
                this.option.series[7].data = res.data.pastWeights;
                this.chart = echarts.init(this.$refs["main"]);
                this.chart.setOption(this.option);
                this.is_ok = true;
            }).catch(err=>{
                this.is_ok = true;
            });
        }
    },
    created() {

    },
    mounted() {
        this.getData(1);
    }
}
</script>

<style scoped lang="scss">
.select_btn{
    position: absolute;
    top: 0px;
    right: 0px;
}
</style>
